/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Workspace } from '../models/Workspace';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class WorkspaceService {
    /**
     * Add a new workspace
     * @param requestBody
     * @returns any Successfully added a workspace
     * @throws ApiError
     */
    public static postWorkspace(
        requestBody: {
            name: string;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/workspace',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Not supported`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Get a workspace
     * @param workspaceId Workspace ID is required in every request
     * @returns Workspace Successfully retrieved Workspace
     * @throws ApiError
     */
    public static getWorkspace(
        workspaceId: string,
    ): CancelablePromise<Workspace> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/workspace',
            query: {
                'workspace_id': workspaceId,
            },
            errors: {
                500: `Internal server error`,
            },
        });
    }
    /**
     * Delete a workspace
     * @param workspaceId Workspace ID is required in every request
     * @returns any Successfully deleted workspace
     * @throws ApiError
     */
    public static deleteWorkspace(
        workspaceId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/workspace',
            query: {
                'workspace_id': workspaceId,
            },
            errors: {
                500: `Internal server error`,
            },
        });
    }
    /**
     * Update a Workspace
     * @param workspaceId Workspace ID is required in every request
     * @param requestBody
     * @returns any Successfully updated workspace
     * @throws ApiError
     */
    public static patchWorkspace(
        workspaceId: string,
        requestBody: {
            name: string;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/workspace',
            query: {
                'workspace_id': workspaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Not authorized`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Update workspace currency settings
     * @param workspaceId Workspace ID is required in every request
     * @param requestBody
     * @returns any Successfully updated
     * @throws ApiError
     */
    public static patchWorkspaceCurrency(
        workspaceId: string,
        requestBody: {
            currency: string;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/workspace/currency',
            query: {
                'workspace_id': workspaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Not authorized`,
                404: `Not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Update workspace timezone settings
     * @param workspaceId Workspace ID is required in every request
     * @param requestBody
     * @returns any Successfully updated
     * @throws ApiError
     */
    public static patchWorkspaceTimezone(
        workspaceId: string,
        requestBody: {
            timezone: string;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/workspace/timezone',
            query: {
                'workspace_id': workspaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                403: `Not authorized`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * List of workspace
     * @returns Workspace Successfully retrieved workspace list
     * @throws ApiError
     */
    public static getWorkspaceList(): CancelablePromise<Workspace> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/workspace/list',
            errors: {
                500: `Internal server error`,
            },
        });
    }
}
